@import 'styles/mixins';

.wrapper {
  display: flex;
  background: var(--neutral-1);
  width: 100%;
  border: 1px solid var(--neutral-90);

  @include for-tablet-portrait-max {
    border: none;
  }
}

.container {
  background-color: var(--neutral-1);
  display: flex;
  margin: 24px 36px 24px 36px;
  flex-direction: column;
  align-items: flex-start;
  width: 390px;

  @include for-tablet-portrait-max {
    border: 1px solid var(--neutral-90);
    padding: 32px 30px 24px 30px;
    margin: 12px 12px 12px 0;
  }

  .content {
    background-color: var(--neutral-1);
    display: flex;
    flex-direction: column;
    gap: 100px;
    margin: 0 auto;
    width: 100%;

    @include for-tablet-portrait-max {
      padding: 44px 20px 24px 20px;
      gap: 28px;
      flex-grow: 1;
      max-width: 530px;
      justify-content: space-between;
      margin: 0 auto;
      align-items: center;
    }

    .bottomContent {
      display: flex;
      flex-direction: column;
      gap: 32px;
      width: 100%;
    }
  }

  @include for-tablet-portrait-max {
    margin: 0;
    border: none;
    width: 100%;
    min-height: 100vh;
    padding: 0;
  }

  .items {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .header {
    width: 100%;
    align-items: center;
    height: 44px;

    @include for-tablet-portrait-max {
      align-items: unset;
      height: 64px;
    }

    .backButton {
      margin: 0 10px 0 -10px;

      @include for-tablet-portrait-max {
        margin: 10px 0 0 10px;
      }
    }
  }

  .subtitle {
    @include lg-medium;
    color: var(--neutral-90);
    width: 100%;
    max-width: 345px;
    margin: 16px 0 28px 0;

    @include for-tablet-portrait-max {
      @include md-medium;
      margin-top: 4px;
      margin-bottom: 0;
      align-self: center;
      text-align: center;
      padding: 0 16px;
    }
  }

  .title {
    text-align: center;
    text-transform: none;
    margin-bottom: 0;
    font-size: 26px;

    @include for-tablet-portrait-max {
      width: 100%;
      margin-bottom: 4px;
    }
  }

  .item {
    display: flex;
    gap: 16px;
    align-items: center;
    z-index: 1;
    position: relative;

    @include for-tablet-portrait-max {
      width: 260px;
    }

    .icon {
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;

      svg {
        margin-right: 2px;
      }
    }
  }

  .submitButton {
    width: 100%;
  }

  .smallPrint {
    @include xxs-medium;
    font-weight: 400;
    color: var(--neutral-40);
    text-align: center;
    width: 100%;
    margin-top: -20px;
  }

  .loadingSpinner {
    display: flex;
    height: 310px;
    align-items: center;
    justify-content: center;
  }
}
